module.exports = __webpack_public_path__ + "img/user.7aebc084.svg";